import React from "react";

import { TypographyPresenter, PresenterProps } from "./Typography";

type TypographyProps = PresenterProps;

export const Typography: React.FC<TypographyProps> = (props) => {
  return <TypographyPresenter {...props}></TypographyPresenter>;
};
